import { Component, Inject, OnInit, ViewChild } from "@angular/core";

import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import CryptoJS from "crypto-js";
import { APP_CONFIG, IAppConfig } from "src/app/app.config";
import * as moment from "moment";
import { PlyrComponent } from "ngx-plyr";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  @ViewChild(PlyrComponent) plyr: PlyrComponent;
  private ls = new SecureLS({ encodingType: "aes" });
  public datasets: any;
  public data: any;
  public salesChart;
  public clicked: boolean = true;
  public clicked1: boolean = false;
  vendordashboard: any;
  vendor: any;
  superdashboard: Object;
  isLoginType: boolean;
  super: any;
  professor_count: any;
  student_count: any;
  vendor_count: any;
  vendor_professor_count: any;
  vendor_student_count: any;
  vendor_audioDevice_count: any;
  vendor_batch_count: any;
  vendor_camera_count: any;
  vendor_classroom_count: any;
  vendor_course_count: any;
  vendor_department_count: any;
  vendor_rasberry_count: any;
  vendor_session_count: any;
  vendor_subject_count: any;
  vendorschedule: Object;
  vendorsched: any;
  page: number = 1;
  page_size: number = 10;
  professorvideoList: any;
  professorvideo: any;
  videoApproved: Object;
  video: any;
  prolength: any;
  venlength: any;
  viewedList:any;
  videodec: any;
  showvideo = false;
  viewvideo = false;
  videosrc: any;
  dataindex: any;
  fileserver_count: any;
  student_expiry_count: any;
  accessed_student: any;
  connected_camera: any;
  connected_fileserver: any;
  connected_rasberry: any;
  professorvideo1 = [];
  professor: any;
  userid: any;
  departmentid: any;
  batchid: any;
  professorid: any;
  subjectlist: boolean;
  subject_id: any;
  section: any;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    @Inject(APP_CONFIG) private config: IAppConfig,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute
  ) { }
  roleId = this.storageService.getRole();
  ngOnInit() {
    this.subjectlist = false;
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
      } else {
        this.roleId = this.storageService.getRole();
      }
    });
    if (this.roleId === 2 || this.roleId === 3) {
      this.getvendordashboard();
      this.getvendorschedule();      
    }
    if (this.roleId === 1) {
      this.getsuperdashboard();
    }
    if (this.roleId === 4 || this.roleId === 5) {
      this.getprofessorvideoList();
    }
  }
  async getvendordashboard() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.vendordashboard = await this.globalService.get(
      "user/vendor-dashboard-usercount",
      filter
    );

    this.vendor = this.vendordashboard["content"];
    this.vendor_professor_count = this.vendor.professor_count;
    this.vendor_student_count = this.vendor.student_count;
    this.vendor_audioDevice_count = this.vendor.audioDevice_count;
    this.vendor_batch_count = this.vendor.batch_count;
    this.vendor_camera_count = this.vendor.camera_count;
    this.vendor_classroom_count = this.vendor.classroom_count;
    this.vendor_course_count = this.vendor.course_count;
    this.vendor_department_count = this.vendor.department_count;
    this.vendor_rasberry_count = this.vendor.rasberry_count;
    this.vendor_session_count = this.vendor.session_count;
    this.vendor_subject_count = this.vendor.subject_count;
    this.fileserver_count = this.vendor.fileserver_count;
    this.student_expiry_count = this.vendor.student_expiry_count;
    this.accessed_student = this.vendor.accessed_student;
    this.connected_camera = this.vendor.connected_camera;
    this.connected_fileserver = this.vendor.connected_fileserver;
    this.connected_rasberry = this.vendor.connected_rasberry;
    this.spinner.hide();
  }
  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }

  async getvendorschedule() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.vendorschedule = await this.globalService.get(
      "timetable/dashboard-upcoming-schedule",
      filter
    );
    this.vendorsched = this.vendorschedule["content"];
    this.venlength = this.vendorsched.length;
  }

  
  async videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    let key = id;
    if (this.route.queryParams["value"].loginType == "impersonate") {
      window.open(
        `/video/play?key=${key}&loginType=impersonate&isHls=${encrypt(
          enryptText
        )}`,
        "_blank"
      );
    } else {
      window.open(
        `/video/play?key=${key}&isHls=${encrypt(enryptText)}`,
        "_blank"
      );
    }
  }
  async videoApprove(id) {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      id: id,
      is_video_approval: "1",
    };
    this.videoApproved = await this.globalService.update(
      "classVideoDetail/update-video-approval",
      filter
    );
    this.video = this.videoApproved["content"];
    this.getprofessorvideoList();
  }
  async getprofessorvideoList() {
    this.spinner.show();
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        if (this.roleId == 4){
          this.professorid = this.ls.get("impersonate_user_id");
        }else {
          this.departmentid = this.ls.get("impersonate_department_id");
          this.batchid = this.ls.get("impersonate_batch_id");
          this.section = this.ls.get("impersonate_section");
         
        }
      } else {
        this.roleId = this.storageService.getRole();
        if (this.roleId == 4) {this.professorid = this.ls.get("createdBy");
      }else {
          this.departmentid = this.storageService.getDepartment();
          this.batchid = this.ls.get("batch_id");
          this.section = this.ls.get("section");
        }
      }
    });
    let filter = {};
    if (this.roleId === 4) {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        professor_id: this.professorid
      };
      this.professorvideoList = await this.globalService.get(
        "classVideoDetail/get-student-video",
        filter
      );
      this.professorvideo = this.professorvideoList["content"]["rows"];
      this.prolength = this.professorvideoList["content"].count;
      this.professorvideo.map((item) => {
        this.professorvideo1.push(item);
      });
    }
    if (this.roleId === 5) {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        department_id: this.departmentid,
        batch_id: this.batchid
      };
      if(this.ls.get("student_dashboard_section_filter")){
        filter["section"] = this.section
      }
      this.professorvideoList = await this.globalService.get(
        "classVideoDetail/get-student-video",
        filter
      );
      this.professorvideo = this.professorvideoList["content"]["rows"];

      this.prolength = this.professorvideoList["content"].count;
      this.professorvideo.map((item) => {
        this.professorvideo1.push(item);
      });
    }
    this.spinner.hide();
  }

  increaseShow() {
    this.page += 1;
    this.subjectList(this.batchid, this.departmentid, this.subject_id, true);
  }
  onCallHome(){
    if (this.roleId === 4 || this.roleId === 5) {
      this.subjectlist = false;
      this.professorvideo1 = [];
      this.getprofessorvideoList();
    }
  }
  async subjectList(batch_id, department_id, subject_id, isLoadMore?) {
    this.spinner.show();
    this.subjectlist = true;
    this.batchid = batch_id;
    this.departmentid = department_id;
    this.subject_id = subject_id;
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        if (this.roleId == 4)
          this.professorid = this.ls.get("impersonate_user_id");
        else {
          this.departmentid = this.ls.get("impersonate_department_id");
          this.batchid = this.ls.get("impersonate_batch_id");
        }
      } else {
        this.roleId = this.storageService.getRole();
        if (this.roleId == 4) this.professorid = this.ls.get("createdBy");
        else {
          this.departmentid = department_id;
          this.batchid = batch_id;
        }
      }
    });

    if (this.roleId === 4) {
      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        professor_id: this.professorid,
        subject_id: subject_id,
        resolution_type: "low",
      };
      this.professorvideoList = await this.globalService.get(
        "classVideoDetail/get-video-bysubjects",
        filter
      );

      this.professorvideo = this.professorvideoList["content"]["rows"];
      if (this.professorvideoList["status"] === 200) {
        this.showvideo = true;
      }
      this.prolength = this.professorvideoList["content"].count;
      if (!isLoadMore) {
        this.professorvideo1 = [];
      }
      this.professorvideo.map((item) => {
        this.professorvideo1.push(item);
      });
    }
    if (this.roleId === 5) {
      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        department_id: this.departmentid,
        subject_id: subject_id,
        batch_id: this.batchid,
        resolution_type: "low",
      };
      this.professorvideoList = await this.globalService.get(
        "classVideoDetail/get-video-bysubjects",
        filter
      );

      this.professorvideo = this.professorvideoList["content"]["rows"];
      if (this.professorvideoList["status"] === 200) {
        this.showvideo = true;
      }
      this.prolength = this.professorvideoList["content"].count;
      if (!isLoadMore) {
        this.professorvideo1 = [];
      }
      this.professorvideo.map((item) => {
        this.professorvideo1.push(item);
      });
    }

    this.spinner.hide();
  }
  async getsuperdashboard() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.superdashboard = await this.globalService.get(
      "user/superadmin-dashboard-usercount",
      filter
    );

    this.super = this.superdashboard["content"];
    this.professor_count = this.super.professor_count;
    this.student_count = this.super.student_count;
    this.vendor_count = this.super.vendor_count;
    this.spinner.hide();
  }
  public updateOptions() {
    this.salesChart.data.datasets[0].data = this.data;
    this.salesChart.update();
  }
  res() {
    this.showvideo = false;
    this.viewvideo = false;

    this.getprofessorvideoList();
  }
}
